import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgUser = (props) => {
    const { color } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 8A6 6 0 1 1 6 8a6 6 0 0 1 12 0Zm-2 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z", fill: color }),
        React.createElement("path", { d: "M19.877 21.265C18.75 18.758 16.12 17 13.057 17h-2.115c-3.063 0-5.692 1.758-6.819 4.265-.192.427-.609.735-1.09.735-.704 0-1.226-.637-.965-1.269C3.452 17.377 6.903 15 10.942 15h2.116c4.038 0 7.49 2.377 8.874 5.731.26.632-.261 1.269-.965 1.269-.481 0-.898-.308-1.09-.735Z", fill: color })));
};
export default factorySvgIcon(SvgUser);
//# sourceMappingURL=SvgUser.js.map